import { Box } from '@mui/material';
import Headline6 from 'components/elements/Headline6';
import ContentNormal from 'components/elements/ContentNormal';
import { translate } from 'utils/Translate';
import { useContext } from 'react';
import { AppContext } from 'contexts/AppContext';

function OrderTrackingDeliveryDetails(props) {
  const { confirmation } = props;
  const { styleGuide } = useContext(AppContext);

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: styleGuide.color2,
        padding: { xs: 3, sm: 4 },
        paddingBottom: 8,
        gap: 1,
        borderRadius: 4,
        minWidth: 250,
      }}
    >
      <Headline6 style={{ marginBottom: 10 }} translationKey="_BASKET_OVERVIEW_DELIVERY_INFORMATION_CAPTION_" fallbackText="Leveringsoplysninger" />
      <ContentNormal>
        {confirmation.orderConsigneeName}
        <br />
        {`${confirmation.orderConsigneeAddress1}, ${confirmation.orderConsigneeZipcode} ${confirmation.orderConsigneeCity}`}
        <br />
        {confirmation.orderConsigneeEmail || ''}
        <br />
        {!confirmation.orderConsigneePhone ? translate('_USER_PHONE_NOT_AVAILABLE_', 'Telefonnummer er ikke tilgængeligt') : confirmation.orderConsigneePhone}
      </ContentNormal>
    </Box>
  );
}

export default OrderTrackingDeliveryDetails;